import React, { useRef, Fragment, useState } from "react";
import img1 from "../../assets/client1.webp";
import img2 from "../../assets/client2.webp";
import img5 from "../../assets/client5.webp";
import img3 from "../../assets/client7.webp";
import img23 from "../../assets/client23.webp";
import img24 from "../../assets/client24.webp";
import img9 from "../../assets/client9.png";
import img10 from "../../assets/client10.png";
import { GrClose } from "react-icons/gr";

import "video-react/dist/video-react.css";

import "./Project.css";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const people = [
  {
    id: 1,
    name: "RECENT PROJECTS",
  },
  {
    id: 2,
    name: "BILLBOARDS",
  },
  {
    id: 3,
    name: "TRANSIT ADVERTISING",
  },
  {
    id: 4,
    name: "ALL",
  },
];

const Projects = () => {
  const currentNav =
    (localStorage.getItem("nav") == "CAR" && people[2]) ||
    (localStorage.getItem("nav") == "BILLBOARDS" && people[1]) ||
    (localStorage.getItem("nav") == "ALL" && people[3]) ||
    people[0];

  localStorage.removeItem("nav");

  const [selected, setSelected] = useState(currentNav);
  const [visible, setVisible] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  // const playerRef = useRef(null);

  var active = selected.name;

  const showModal = (videoPath) => {
    setVideoSrc("");
    videoPath == "video1" &&
      setVideoSrc("https://www.youtube.com/embed/AGcLZGylW1s");
    videoPath == "video5" &&
      setVideoSrc("https://www.youtube.com/embed/Ya6SWnscls4");
    videoPath == "video3" &&
      setVideoSrc("https://www.youtube.com/embed/gQYaBzDCBUc");
    videoPath == "video4" &&
      setVideoSrc("https://www.youtube.com/embed/GofLlfNaJi4");
    videoPath == "video6" &&
      setVideoSrc("https://www.youtube.com/embed/QnTSjLR6heI");
    videoPath == "video8" &&
      setVideoSrc("https://www.youtube.com/embed/dwOZz0Lljvo");
    videoPath == "video9" &&
      setVideoSrc("https://www.youtube.com/embed/55irJe2ZkvM");
      videoPath == "video10" &&
      setVideoSrc("https://www.youtube.com/embed/WAOhVQrm_8A");
    setVisible(true);
  };

  const navActive = (obj) => {
    setSelected(obj);
    setVisible(false);
  };

  return (
    <div className="mt-4">
      <div
        style={{ width: "50%" }}
        className="text-white border-r h-20 mb-8"
      ></div>
      <p className="text-white flex justify-center">TRUSTED PARTNERS</p>
      <h2 className="border-l-0 pl-0 text-center">
        OUR <span>PROJECTS</span>
      </h2>

      <div id="project-nav" className="flex justify-center">
        <div className="w-2/4 flex justify-between text-white">
          <span
            onClick={() => navActive(people[0])}
            style={
              active == "RECENT PROJECTS"
                ? { color: "#FBC213" }
                : { color: "white" }
            }
          >
            RECENT PROJECTS
            {/* <p className=' bg-yellow-500'></p> */}
          </span>
          <span
            onClick={() => navActive(people[1])}
            style={
              active == "BILLBOARDS" ? { color: "#FBC213" } : { color: "white" }
            }
          >
            {" "}
            BILLBOARDS
          </span>
          <span
            onClick={() => navActive(people[2])}
            style={
              active == "TRANSIT ADVERTISING"
                ? { color: "#FBC213" }
                : { color: "white" }
            }
          >
            {" "}
            TRANSIT ADVERTISING
          </span>
          <span
            onClick={() => navActive(people[3])}
            style={active == "ALL" ? { color: "#FBC213" } : { color: "white" }}
          >
            {" "}
            ALL
          </span>
        </div>
      </div>

      <div id="dropdown" className="px-10">
        <Listbox value={selected} onChange={setSelected}>
          {({ open }) => (
            <>
              <div className="relative mt-2">
                <Listbox.Button className="relative w-full cursor-default rounded-md  py-1.5 pl-3 pr-10 text-left text-yellow-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-500 sm:text-sm sm:leading-6">
                  <span className="flex items-center">
                    <span className="ml-3 block truncate">{selected.name}</span>
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                    <ChevronUpDownIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>

                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    {people.map((person) => (
                      <Listbox.Option
                        key={person.id}
                        className={({ active }) =>
                          classNames(
                            active
                              ? "bg-yellow-500 text-white"
                              : "text-gray-900",
                            "relative cursor-default select-none py-2 pl-3 pr-9"
                          )
                        }
                        value={person}
                      >
                        {({ selected, active }) => (
                          <>
                            <div className="flex items-center">
                              <span
                                className={classNames(
                                  selected ? "font-semibold" : "font-normal",
                                  "ml-3 block truncate"
                                )}
                              >
                                {person.name}
                              </span>
                            </div>

                            {selected ? (
                              <span
                                className={classNames(
                                  active ? "text-white" : "text-indigo-600",
                                  "absolute inset-y-0 right-0 flex items-center pr-4"
                                )}
                              >
                                <CheckIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      </div>

      {active == "RECENT PROJECTS" ? (
        <div
          id="client-comp"
          className="flex my-8 justify-center flex-wrap px-20"
        >
          {visible == true && (
            <div id="video-popup">
              <p onClick={() => setVisible(false)} id="modal-close-btn">
                <GrClose />
              </p>
              <iframe
                src={videoSrc}
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
          )}

           <img
           alt='vwrap'
            onClick={() => showModal("video10")}
            className="cursor-pointer"
            src={img10}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video9")}
            className="cursor-pointer"
            src={img9}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video4")}
            className="cursor-pointer"
            src={img23}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video8")}
            className="cursor-pointer"
            src={img3}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video6")}
            className="cursor-pointer"
            src={img24}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video5")}
            className="cursor-pointer"
            src={img5}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video3")}
            className="cursor-pointer"
            src={img2}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video1")}
            className="cursor-pointer"
            src={img1}
          />
        </div>
      ) : (
        ""
      )}

      {active == "BILLBOARDS" ? (
        <div
          id="client-comp"
          className="flex my-8 justify-center flex-wrap px-20"
        >
          {visible == true && (
            <div id="video-popup">
              <p onClick={() => setVisible(false)} id="modal-close-btn">
                <GrClose />
              </p>
              <iframe
                src={videoSrc}
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
          )}
           <img
           alt='vwrap'
            onClick={() => showModal("video10")}
            className="cursor-pointer"
            src={img10}
          />

          <img
          alt='vwrap'
            onClick={() => showModal("video9")}
            className="cursor-pointer"
            src={img9}
          />

          <img
          alt='vwrap'
            onClick={() => showModal("video4")}
            className="cursor-pointer"
            src={img23}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video8")}
            className="cursor-pointer"
            src={img3}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video6")}
            className="cursor-pointer"
            src={img24}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video5")}
            className="cursor-pointer"
            src={img5}
          />
        </div>
      ) : (
        ""
      )}

      {active == "TRANSIT ADVERTISING" ? (
        <div
          id="client-comp"
          className="flex my-8 justify-center flex-wrap px-20"
        >
          {visible == true && (
            <div id="video-popup">
              <p onClick={() => setVisible(false)} id="modal-close-btn">
                <GrClose />
              </p>
              <iframe
                src={videoSrc}
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
          )}

          <img
          alt='vwrap'
            onClick={() => showModal("video1")}
            className="cursor-pointer"
            src={img1}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video3")}
            className="cursor-pointer"
            src={img2}
          />
        </div>
      ) : (
        ""
      )}

      {active == "ALL" ? (
        <div
          id="client-comp"
          className="flex my-8 justify-center flex-wrap px-20"
        >
          {visible == true && (
            <div id="video-popup">
              <p onClick={() => setVisible(false)} id="modal-close-btn">
                <GrClose />
              </p>
              <iframe
                src={videoSrc}
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
          )}

<img
            onClick={() => showModal("video10")}
            className="cursor-pointer"
            src={img10}
          />

          <img
          alt='vwrap'
            onClick={() => showModal("video9")}
            className="cursor-pointer"
            src={img9}
          />

          <img
          alt='vwrap'
            onClick={() => showModal("video4")}
            className="cursor-pointer"
            src={img23}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video8")}
            className="cursor-pointer"
            src={img3}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video6")}
            className="cursor-pointer"
            src={img24}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video5")}
            className="cursor-pointer"
            src={img5}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video3")}
            className="cursor-pointer"
            src={img2}
          />
          <img
          alt='vwrap'
            onClick={() => showModal("video1")}
            className="cursor-pointer"
            src={img1}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Projects;
